function decamelize(str, separator) {
  const spr = typeof separator === 'undefined' ? '_' : separator;
  return str
    .replace(/([a-z\d])([A-Z])/g, '$1' + spr + '$2')
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + spr + '$2')
    .toLowerCase();
}

export const toLowerCase = function(origObj) {
  return Object.keys(origObj).reduce((newObj, key) => {
    let val = origObj[key];
    newObj[decamelize(key)] = typeof val === 'object' ? toLowerCase(val) : val;
    return newObj;
  }, {});
};



// WEBPACK FOOTER //
// ./app/javascript/common/utils/params.js